<template>
  <ul class="wizard-nav mb-4">
    <li v-for="(step, index) in maxSteps" :class="{'current' : currentStep === index + 1}" :key="index">
      <a href>&nbsp;</a>
    </li>
  </ul>
</template>

<script>
module.exports = {
  props: ["currentStep", "maxSteps"],
  name: "WizardSteps"
};
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

.wizard-nav {
  list-style-type: none;
  display: flex;
  width: 100%;
  padding: 0;

  li {
    height: 4px;
    display: flex;
    flex: 1;
    margin-right: 10px;
    background: #c4c4c4;

    &:last-child {
      margin-right: 0;
    }

    &.current {
      background: $primary;
    }
  }

  a {
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
  }
}
</style>
